exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-boxed{\r\n    width:100%;\r\n    padding-bottom: 1.5rem;\r\n}\r\n\r\n.bg-fotos {\r\n    background-color: #313131;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/hyago/Desktop/SiteEventos/src/app/inf-intinerante/inf-intinerante.component.css
// module id = ../../../../../src/app/inf-intinerante/inf-intinerante.component.css
// module chunks = main